// assets/cart-drawer-shipping-banner.js
// Free-shipping banner that survives Dawn cart drawer re-renders.
// - Re-queries DOM on each update (no stale refs)
// - Listens to common cart events + DOM mutations
// - Debounced updates to avoid spamming /cart.js
(function(){
  const CURRENCY = 'EUR';
  const LOCALE = 'fr-FR';

  const fmtMoney = (cents) => {
    try { return new Intl.NumberFormat(LOCALE, { style: 'currency', currency: CURRENCY }).format((cents || 0) / 100); }
    catch { return ((cents||0)/100).toFixed(2) + ' €'; }
  };

  // Debounce helper
  let debounceTO;
  const debounce = (fn, wait=300) => {
    return () => {
      clearTimeout(debounceTO);
      debounceTO = setTimeout(fn, wait);
    };
  };

  async function fetchCart(){
    const res = await fetch('/cart.js', { headers: {Accept:'application/json'}, credentials:'same-origin' });
    if (!res.ok) throw new Error('cart fetch failed');
    return res.json();
  }

  function getRefs(){
    // Any container (drawer or page) that carries the threshold
    const roots = Array.from(document.querySelectorAll('[data-free-shipping-threshold]'));
    if (!roots.length) return { banners: [], threshold: 0 };

    // All roots should share the same threshold; we read it from the first one
    const threshold = Number(roots[0].dataset.freeShippingThreshold || 0);

    // Collect all banners that live inside these roots
    const banners = roots.flatMap((root) =>
      Array.from(root.querySelectorAll('[data-free-shipping-banner]'))
    );

    return { roots, banners, threshold };
  }

  async function updateBanner(){
    const { banners, threshold } = getRefs();
    if (!banners || !banners.length || !Number.isFinite(threshold) || threshold <= 0) return;

    try {
      const cart = await fetchCart();
      if (!cart || typeof cart.total_price !== 'number') return;

      if (cart.item_count === 0){
        banners.forEach((banner) => {
          banner.hidden = true;
        });
        return;
      }

      const missing = threshold - cart.total_price;

      if (missing > 0){
        const text = `Plus que ${fmtMoney(missing)} pour bénéficier de la livraison gratuite.`;
        banners.forEach((banner) => {
          banner.textContent = text;
          banner.hidden = false;
        });
      } else {
        const text = 'Vous pouvez bénéficier de la livraison gratuite !';
        banners.forEach((banner) => {
          banner.textContent = text;
          banner.hidden = false;
        });
      }
    } catch (e) {
      // Silent fail to avoid console noise in production
    }
  }

  const updateBannerDebounced = debounce(updateBanner, 350);

  // Initial run (if drawer already in DOM)
  updateBanner();

  // Global listeners that survive re-renders
  document.addEventListener('cart:updated', updateBannerDebounced);
  document.addEventListener('cart:refresh', updateBannerDebounced);
  document.addEventListener('cart-drawer:open', updateBannerDebounced);
  document.addEventListener('shopify:section:load', updateBannerDebounced);

  // Delegate interactions inside the drawer (even if it gets replaced)
  document.addEventListener('click', (e) => {
    const t = e.target;
    if (!t) return;
    if (t.closest && t.closest('#CartDrawer')){
      if (t.closest('.quantity__button') || t.closest('.cart-remove-button')){
        updateBannerDebounced();
      }
    }
  }, true);

  document.addEventListener('input', (e) => {
    const t = e.target;
    if (!t) return;
    if (t.closest && t.closest('#CartDrawer')){
      if (t.matches('.quantity__input')){
        updateBannerDebounced();
      }
    }
  }, true);

  // Observe DOM changes to detect when the drawer or banner is re-inserted
  const mo = new MutationObserver(updateBannerDebounced);
  mo.observe(document.documentElement || document.body, { childList: true, subtree: true });
})();
